import { ResolveFn } from '@angular/router';
import { EMPTY, Observable, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { NavigatorService } from '@core/routing/routes/services/navigator.service';
import { RouteParam } from '@core/routing/routes/enums/route-param';
import { isNil } from '@core/utils/nil/is-nil';
import { Route } from '@core/routing/routes/enums/route';
import { SequenceSearchResult } from '@features/sequence/models/sequence-search-result';
import { SequenceSearchResultActionService } from '@features/sequence/services/sequence-search-result-action.service';

export const SequenceSearchResultResolver: ResolveFn<SequenceSearchResult> = (
  route
): Observable<SequenceSearchResult> => {
  const action = inject(SequenceSearchResultActionService);
  const navigator = inject(NavigatorService);
  const id = route.paramMap.get(RouteParam.SequenceSearchResultId);

  return of(id).pipe(
    switchMap(id => {
      if (isNil(id)) {
        navigator.navigateByRouterLink(provider =>
          provider.routerLink(Route.NotFound)
        );

        return EMPTY;
      }

      return action.fetch(id);
    })
  );
};
